/* eslint-disable react/display-name */
import { chakra, useStyleConfig } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { ThemeColors } from '@theme/foundations/colors';
import { DropdownOptionProps } from './DropdownOptionProps';
import BEIcon from '@molecules/BEIcon';

interface OptionProps {
  hasIcon?: boolean;
  hasImage?: boolean;
  isSelected?: boolean;
}

const Option = chakra('li');
const StyledOption = styled(({ hasIcon, hasImage, isSelected, ...props }) => (
  <Option {...props} />
))<OptionProps>`
  grid-template-columns: ${({ hasImage, hasIcon }) => {
    let columns = ['auto', 'max-content'];

    if (hasImage) {
      columns = ['24px', ...columns];
    }

    if (hasIcon) {
      columns = ['max-content', ...columns];
    }

    return columns.join(' ');
  }};

  background-color: ${({ isSelected }) =>
    isSelected ? ThemeColors.neutral['100'] : ThemeColors.white};
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};

  &:hover {
    background-color: ${({ isSelected }) =>
      isSelected ? ThemeColors.neutral['300'] : ThemeColors.neutral['100']};
  }

  * {
    pointer-events: none;
  }
`;

const DropdownOption = forwardRef<HTMLLIElement, DropdownOptionProps>(
  ({ children, icon, image, isSelected, showCheck, value, ...rest }, ref) => {
    const styles = useStyleConfig('DropdownOption');

    return (
      <StyledOption
        {...rest}
        hasIcon={Boolean(icon)}
        hasImage={Boolean(image)}
        isSelected={isSelected}
        ref={ref}
        value={value}
        __css={styles}
      >
        {children}
        {showCheck && (
          <BEIcon
            name="check"
            size="sm"
            style={{ opacity: isSelected ? 1 : 0 }}
          />
        )}
      </StyledOption>
    );
  }
);

export default DropdownOption;
